module.exports = __webpack_public_path__ + "img/coin_2.d6fc4bff.png";